import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { ClientPortalWrapper } from './layout/ClientPortalWrapper';

const ProtectedContent = ({ children, requiredRole, requiredFeature }) => {
  const user = authService.getCurrentUser();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Si requiere Admin y el usuario es Agente, redirigir a la página de chats
  const roleLower = user.role?.toLowerCase();
  const isAdmin = roleLower === 'admin' || roleLower === 'super_admin';
  if (requiredRole === 'admin' && !isAdmin) {
    return <Navigate to="/client/chats" replace />;
  }
  
  // Envolver en ClientPortalWrapper para aplicar el tema
  return <ClientPortalWrapper requiredFeature={requiredFeature}>{children}</ClientPortalWrapper>;
};

export const ProtectedRoute = ({ children, requiredRole, requiredFeature }) => {
  const user = authService.getCurrentUser();
  
  // Si no hay usuario, redirigir inmediatamente sin usar hooks
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return <ProtectedContent requiredRole={requiredRole} requiredFeature={requiredFeature}>{children}</ProtectedContent>;
};
